import { FC } from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { RootState } from 'store/store';
import { Box, Button, Stack, Typography } from 'styles';
import { IPaymentClaim } from 'types/Payment';
import { PATHNAMES } from 'utils/constants';
import { useTranslation } from 'utils/translations';
import { formatDateWithoutZulu, formatPrice, getShortDate } from 'utils/utils';
import { boxListRowBoxSX, claimListRowSX } from './PaymentClaimsList.component';

const PaymentClaimsListItem: FC<{ paymentClaim: IPaymentClaim }> = ({
	paymentClaim,
}) => {
	const { t: tClientLabels } = useTranslation('', {
		keyPrefix: 'clientLabels',
	});
	const { paymentRun } = useSelector((store: RootState) => store.payment);

	return (
		<>
			{
				<Stack direction={'row'} sx={claimListRowSX}>
					<Box sx={boxListRowBoxSX} display={'flex'} justifyContent={'start'}>
						<Typography variant="value3">{paymentClaim.externalClaimId}</Typography>
					</Box>
					<Box sx={boxListRowBoxSX}>
						<Typography variant="value3">
							{getShortDate(paymentClaim.dateOfService)}
						</Typography>
					</Box>
					<Box sx={boxListRowBoxSX}>
						<Typography variant="value3">
							{formatPrice(paymentClaim.totalCharges)}
						</Typography>
					</Box>
					<Box sx={boxListRowBoxSX}>
						<Typography variant="value3">
							{formatPrice(paymentClaim.contractualWriteOff)}
						</Typography>
					</Box>
					<Box sx={boxListRowBoxSX}>
						<Typography variant="value3">
							{formatPrice(paymentClaim.memberResponsible)}
						</Typography>
					</Box>
					<Box sx={boxListRowBoxSX}>
						<Typography variant="value3">
							{formatPrice(paymentClaim.claimPayment)}
						</Typography>
					</Box>
					<Box sx={boxListRowBoxSX}>
						<Typography variant="value3">{formatPrice(paymentClaim.tax)}</Typography>
					</Box>
					<Box sx={boxListRowBoxSX}>
						<Typography variant="value3">
							{formatPrice(paymentClaim.retailNetOfTax)}
						</Typography>
					</Box>
					<Box sx={boxListRowBoxSX}>
						<Typography variant="value3">
							{formatPrice(paymentClaim.assessmentFee)}
						</Typography>
					</Box>
					<Box sx={boxListRowBoxSX}>
						<Typography variant="value3">
							{formatPrice(paymentClaim.assessmentFeeTax)}
						</Typography>
					</Box>
					<Box sx={boxListRowBoxSX}>
						<Typography variant="value3">
							{formatPrice(paymentClaim.eyemedFee)}
						</Typography>
					</Box>
					<Box sx={boxListRowBoxSX}>
						<Typography variant="value3">
							{formatPrice(paymentClaim.pswtAmount || 0)}
						</Typography>
					</Box>
					<Box sx={boxListRowBoxSX}>
						<Typography variant="value3">
							{formatPrice(paymentClaim.netDue)}
						</Typography>
					</Box>
					<Box sx={{ minWidth: '140px', maxWidth: '140px' }}>
						<Typography variant="value3">{paymentClaim.location}</Typography>
					</Box>
					<Box sx={boxListRowBoxSX} display={'flex'} justifyContent={'center'}>
						<Link
							style={{
								textDecoration: 'none',
							}}
							to={`/${PATHNAMES.VIEW_PAYMENT_HISTORY}/${
								paymentRun.paymentRunId
							}|${formatDateWithoutZulu(paymentRun.paymentRunDate)}/${
								PATHNAMES.ASSESSMENT_FEE_INVOICE
							}/${paymentClaim.claimUUID}`}
						>
							<Button variant="linkDark">
								{tClientLabels('payment.labels.viewDetail')}
							</Button>
						</Link>
					</Box>
				</Stack>
			}
		</>
	);
};

export default PaymentClaimsListItem;
